import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Example course page`}</h2>
    <img {...{
      "src": "./../images/60_nomenclature.png",
      "alt": "image"
    }}></img>
    <h2>{`Navigation`}</h2>
    <p>{`You can navigate the course with the `}<inlineCode parentName="p">{`Previous`}</inlineCode>{` and  `}<inlineCode parentName="p">{`Next`}</inlineCode>{` Buttons at the bottom of the page.`}</p>
    <h2>{`Course Elements`}</h2>
    <p>{`You will find the following elements in the course:`}</p>
    <hr />
    <h3>{`📥 STEP`}</h3>
    <p>{`This is a step that you have to perform to advance in the course.
This is not part of the actual installation of CP4AIOPS and the commands are not hidden. So you just have to follow the instructions.`}</p>
    <hr />
    <h3>{`🚀 TASK`}</h3>
    <p>{`This is a task that you have to perform to advance in the course.
You should use the `}<inlineCode parentName="p">{`Link to the Documentation`}</inlineCode>{` to try to figure out how to complete the step.
If you get stuck or want to progress your installation rapidly you can click on the `}<inlineCode parentName="p">{`💡 Solution?`}</inlineCode>{` and follow the outlined steps.`}</p>
    <hr />
    <h2><a href="#" target="_blank">{`🌏 Documentation for the Task`}</a></h2>
    <p>{`This links to the documentation that you will need to complete the Task.`}</p>
    <hr />
    <h2>{`💡 Solution to the current task`}</h2>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`This is an `}<inlineCode parentName="p">{`example command`}</inlineCode>{` that you have to copy and execute in your terminal and that will create a Kubernetes Object`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`cat << EOF | oc apply -f -
apiVersion: operators.coreos.com/v1alpha1
kind: MyKind
metadata:
  name: ibm-operator-catalog
  namespace: openshift-marketplace
spec:
  displayName: ibm-operator-catalog
  publisher: IBM Content
  sourceType: grpc
  image: icr.io/cpopen/ibm-operator-catalog:latest
EOF
`}</code></pre>
          </li>
        </ol>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`This is an `}<inlineCode parentName="p">{`example command`}</inlineCode>{` that you have to copy and execute in your terminal and that will execute Shell commands`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`oc create secret docker-registry ibm-entitlement-key \\
    --docker-username=cp\\
    --docker-password=_entitlement-key_ \\
    --docker-server=cp.icr.io \\
    --namespace=ibm-aiops
`}</code></pre>
          </li>
        </ol>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`This is a Note or Remark`}</p>
            <InlineNotification kind="info" mdxType="InlineNotification">
              <p parentName="li">{`This is an example Note. `}</p>
            </InlineNotification>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <p>{`This gives you a step-by-step solution to the `}<inlineCode parentName="p">{`Task`}</inlineCode>{` at hand.`}</p>
    <p>{`Click on `}<inlineCode parentName="p">{`💡 Solution?`}</inlineCode>{` below to test it and see more details.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      